import LogoMarquee from "../components/LogoMarquee";
import { Reveal } from "../components/Reveal";

export default function ClientsMarquee() {
  return (
    <section className="border-y border-black/5 bg-[#fafafa] py-14 md:py-20" data-testid="clients-section">
      <Reveal>
        <h2 className="text-center font-display font-medium tracking-tighter leading-[1.05] text-3xl md:text-5xl text-[#0a0a0a] max-w-3xl mx-auto px-6 mb-10 md:mb-14">
          The businesses growing with a Quexify right hand
        </h2>
      </Reveal>
      <LogoMarquee />
    </section>
  );
}
